import Image from 'next/image';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PropertyConditions } from '../../../core/estimator/estimator.models';

export const ValConditions: React.FC<{
  onForward: (data: {
    conditions: PropertyConditions;
    propStatus: string;
  }) => void;
}> = ({ onForward }) => {
  const { t } = useTranslation(['valutatore']);
  const { t: tc } = useTranslation();
  const [conditions, setConditions] = useState<PropertyConditions>('');
  const [propStatus, setPropStatus] = useState<string>('');

  return (
    <>
      <div className="valutatore__container__title">
        <Image
          src="/assets/img/valutatore/statocondizioni.jpg"
          alt="statoecondizioni"
          width={32}
          height={32}
        />
        {t('step_three.title')}
      </div>
      <div className="login__form__field__row__label">
        {t('step_three.status')}
      </div>
      <div className="valutatore__container--three_btns">
        {(t('step_three.statuses') as string[]).map(
          (val: string, index: number) => (
            <div
              key={index}
              className={
                'valutatore__container__choiche' +
                (propStatus === val
                  ? ' valutatore__container__choiche--selected'
                  : '')
              }
              onClick={() => setPropStatus(val)}
            >
              {val}
            </div>
          )
        )}
      </div>
      <div className="login__form__field__row__label">
        {t('step_three.condition')}
      </div>
      <div className="valutatore__container--two_columns">
        {Object.entries(t('step_three.conditionsValues')).map(
          ([key, value], index) => (
            <div
              key={index}
              className={
                'valutatore__container__choiche' +
                (conditions === (key as PropertyConditions)
                  ? ' valutatore__container__choiche--selected'
                  : '')
              }
              onClick={() => setConditions(key as PropertyConditions)}
            >
              {value as string}
            </div>
          )
        )}
      </div>
      {!!conditions && !!propStatus && (
        <div
          className="valutatore__container__button_forward"
          onClick={() => onForward({ conditions, propStatus })}
        >
          {tc('next')}
        </div>
      )}
    </>
  );
};
